import { useEffect } from 'react';

interface UsePromptOnUnloadProps {
  showPrompt: boolean;
  onPromptShown: () => void;
}

export const usePromptOnUnload = ({ showPrompt, onPromptShown }: UsePromptOnUnloadProps) => {
  useEffect(() => {
    if (!showPrompt) {
      return;
    }

    const handleUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      onPromptShown();
    };

    if (showPrompt) {
      window.addEventListener('beforeunload', handleUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, [showPrompt, onPromptShown]);
};
